
// Nel tuo componente MapWithResizableFilters
// Nel tuo componente MapWithResizableFilters
export function showNavigableRoute(feature) {
    // Estrai coordinate inizio e fine dalla feature
    const coords = feature.geometry.coordinates;
    const start = coords[0]; // [lon, lat]
    const end = coords[coords.length - 1];

    // URL per l'interfaccia web di OSRM
    const osrmUrl = `https://map.project-osrm.org/?z=13&center=${start[1]},${start[0]}&loc=${start[1]},${start[0]}&loc=${end[1]},${end[0]}&hl=en&alt=0&srv=0`;

    return osrmUrl;
}

export function createStartPointLink(feature) {
    const firstCoord = extractStartPoint(feature)
    if (!firstCoord) return
    const [lng, lat] = firstCoord;
    return `https://www.google.com/maps?q=${lat},${lng}`;
}


export function extractStartPoint(feature) {
    if (!feature) return null;
    const geometry = feature.geometry;
    if (!geometry || !geometry.coordinates) return null;

    switch (geometry.type) {
        case "Point":
            return geometry.coordinates;
        case "LineString":
            return geometry.coordinates[0];
        case "MultiLineString":
            return geometry.coordinates.flat()[0];
        case "Polygon":
            return geometry.coordinates[0][0];
        default:
            return null;
    }
}